/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type PaginationData_pageInfo$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ShopsReviews_queryResult$ref: FragmentReference;
export type ShopsReviews_queryResult = {|
  +vendor_reviews: ?{|
    +related_sorts: $ReadOnlyArray<?{|
      +display_name: ?string,
      +name: ?string,
      +selected: ?boolean,
    |}>,
    +page_info: ?{|
      +$fragmentRefs: PaginationData_pageInfo$ref
    |},
    +result: ?$ReadOnlyArray<?{|
      +ref_id: string,
      +rating: number,
      +review: ?string,
      +purchased_on_ayk: boolean,
      +is_current_user: ?boolean,
      +user: ?{|
        +first_name: ?string,
        +last_name: ?string,
      |},
      +vendor: ?{|
        +ref_id: string,
        +name: ?string,
        +avg_rating: ?number,
        +rating_count: ?number,
        +current_user_review: ?{|
          +ref_id: string,
          +rating: number,
          +review: ?string,
        |},
      |},
    |}>,
    +errors: ?$ReadOnlyArray<?{|
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
      +code: ?number,
    |}>,
  |},
  +$refType: ShopsReviews_queryResult$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rating",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "review",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ShopsReviews_queryResult",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "input",
      "type": "VendorReviewsQueryInput",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "vendor_reviews",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input",
          "type": "VendorReviewsQueryInput"
        }
      ],
      "concreteType": "VendorReviewsQueryResult",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "related_sorts",
          "storageKey": null,
          "args": null,
          "concreteType": "SortOption",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "display_name",
              "args": null,
              "storageKey": null
            },
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "selected",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "page_info",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PaginationData_pageInfo",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "result",
          "storageKey": null,
          "args": null,
          "concreteType": "VendorReview",
          "plural": true,
          "selections": [
            v1,
            v2,
            v3,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "purchased_on_ayk",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "is_current_user",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "user",
              "storageKey": null,
              "args": null,
              "concreteType": "UserPublicInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "first_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "last_name",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "vendor",
              "storageKey": null,
              "args": null,
              "concreteType": "Shop",
              "plural": false,
              "selections": [
                v1,
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "avg_rating",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "rating_count",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "current_user_review",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "VendorReview",
                  "plural": false,
                  "selections": [
                    v1,
                    v2,
                    v3
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "errors",
          "storageKey": null,
          "args": null,
          "concreteType": "Error",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "field",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "messages",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '9ff189f1f348faca8dc9f213a4aa24b4';
module.exports = node;
